import * as actionTypes from './actionTypes';
import { ALL_PAYMENT_TYPES, ALL_STATES, ALL_USERS } from './constants';
import * as actionTypesSidebar from '@app/src/commons/sidebar/state/sidebar/actionTypes';
import { getStartDate, getEndDate } from './selectors';
import { decodeAccessToken } from '@app/src/helpers/decodeAccessToken';

let isAdmin: boolean = decodeAccessToken('isAdmin');
let idUser: number = decodeAccessToken('idUser');

const isValidStorage = sessionStorage.length > 0;

interface State {
  dateStart: string;
  dateEnd: string;
  stateId: number | string;
  userId: number | string;
  cip?: number;
  documentNumber?: string;
}

const initialState = {
  dateStart: getStartDate(),
  dateEnd: getEndDate(),
  stateId: ALL_STATES,
  userId: isValidStorage ? (isAdmin ? ALL_USERS : idUser) : ALL_USERS,
  paymentType: ALL_PAYMENT_TYPES
};

export const filterValues = (state: State = initialState, action) => {
  switch(action.type) {
    case actionTypes.FILTER_VALUES:
      return action.filter;
    case actionTypesSidebar.RESET_APP_STATE:
      return initialState;
    default:
      return state;
  }
};
